import React from "react";
import ReactDOM from "react-dom/client";
import ComingSoon from "./pages/ComingSoon";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><ComingSoon /></React.StrictMode>);
